import { render, staticRenderFns } from "./orgOnboarding.vue?vue&type=template&id=c109d024&scoped=true"
import script from "./orgOnboarding.vue?vue&type=script&lang=js"
export * from "./orgOnboarding.vue?vue&type=script&lang=js"
import style0 from "./orgOnboarding.vue?vue&type=style&index=0&id=c109d024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c109d024",
  null
  
)

export default component.exports